import { notification, Typography } from 'antd';
import React from 'react';
import { useLocation } from 'react-router';

import { SendUserMessageForm } from '../../../components/SendUserMessageForm';
import { TableCellDescriptions } from '../../../components/TableCellDescriptions';
import { apiClient } from '../../../graphql/api/apiClient';
import { usesendPropertyPinCodeMutation } from '../../../graphql/api/generated';
import type { PinCodeTableFragment } from '../../../graphql/hasura/generated';
import { PropertyModel } from '../../Property/model';
import { UserModel } from '../../User/model';

interface ISendPropertyPinCodeProps {
  pinCode: PinCodeTableFragment;
  closeModal: () => void;
}

export const SendPropertyPinCode: React.FC<ISendPropertyPinCodeProps> = (props) => {
  const { pinCode, closeModal } = props;
  const { pinCodeId, property, assignedToUser } = pinCode;
  const { pathname } = useLocation();

  const [sendPropertyPinCode, { loading }] = usesendPropertyPinCodeMutation({
    client: apiClient,
  });

  if (!assignedToUser) {
    return null;
  }

  const propertyDescription = pathname === PropertyModel.routes.getRowLinkById(property.propertyId)
    ? PropertyModel.labels.getLabel(property)
    : PropertyModel.routes.renderRowLink(property);

  const userDescription = pathname === UserModel.routes.getRowLinkById(assignedToUser.userId)
    ? UserModel.labels.getLabel(assignedToUser)
    : UserModel.routes.renderRowLink(assignedToUser);

  return (
    <SendUserMessageForm
      user={assignedToUser}
      onSubmit={async (messageMethod) => {
        await sendPropertyPinCode({
          variables: {
            input: {
              pinCodeId,
              messageMethod,
            },
          },
        });

        notification.success({
          message: 'Success',
          description: 'The Property PIN Code was successfully sent!',
        });

        closeModal();
      }}
      onCancel={closeModal}
      submitting={loading}
      description={(
        <Typography.Paragraph>
          <TableCellDescriptions
            descriptions={{
              Property: propertyDescription,
              User: userDescription,
            }}
          />
        </Typography.Paragraph>
      )}
    />
  );
};
